exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".serial-port-container[data-v-efa86154]{padding:20px}.received-message[data-v-efa86154]{margin-bottom:20px;font-size:16px;color:#333}.default-button[data-v-efa86154]{background-color:#fff;color:#409eff;border:1px solid #409eff}.blue-button[data-v-efa86154]{background-color:#409eff;color:#fff}.dock_demo[data-v-efa86154]{padding:20px 50px;//width:600px;//margin:auto;-webkit-box-sizing:border-box;box-sizing:border-box}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-efa86154","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/view/index.vue
// module id = 6Xwb
// module chunks = 1